<template>
  <q-page class="">
    <div class="centered-container fill-height q-px-xl q-pt-xl">
      <div class="row q-mt-lg items-center justify-between q-mb-lg">
        <div class="col-shrink text-left">
          <span class="text-h5">{{ i18n.title }}</span>
        </div>
      </div>

      <div class="row q-gutter-sm q-mb-lg">
        <q-chip
          :class="activeFilter === null ? 'filter-chip-active' : 'filter-chip'"
          clickable
          @click="activeFilter = null"
        >
          {{ i18n.filters_all }}
        </q-chip>
        <q-chip
          v-for="(section, index) in sections"
          :key="index"
          :class="activeFilter === index ? 'filter-chip-active' : 'filter-chip'"
          clickable
          @click="activeFilter = index"
        >
          {{ section.title }}
        </q-chip>
      </div>

      <div
        v-for="(section, sectionIndex) in filteredSections"
        :key="sectionIndex"
        class="q-mb-xl"
      >
        <div
          class="text-h6"
          style="margin-bottom: 40px;"
        >
          {{ section.title }}
        </div>
        <div class="column q-gutter-sm">
          <div
            v-for="(tutorial, index) in section.tutorials"
            :key="index"
            class="tutorial-card row items-center q-pa-md cursor-pointer"
            @click="openVideo(tutorial)"
          >
            <div class="col">
              <div class="text-weight-bold text-body1">
                {{ tutorial.title }}
              </div>
            </div>
            <div class="col-shrink">
              <q-btn
                round
                flat
                icon="las la-play"
                color="dark"
                size="sm"
                @click.stop="openVideo(tutorial)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <q-dialog
      v-model="videoDialog"
      maximized
      transition-show="fade"
      transition-hide="fade"
    >
      <q-card class="video-dialog-card column no-wrap">
        <div class="row justify-end q-pa-md">
          <q-btn
            round
            flat
            icon="las la-times"
            color="grey-8"
            size="md"
            @click="videoDialog = false"
          />
        </div>
        <!-- Loader -->
        <div
          v-if="videoLoading"
          class="loader"
        >
          <q-spinner size="50px" />
        </div>
        <q-card-section class="col column items-center justify-center q-pa-none">
          <div class="video-container">
            <iframe
              v-if="currentVideo"
              :src="currentVideo.video_url"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              @load="currentVideoOnLoad"
            />
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import Layout from '@/layouts/wg_admin.vue';

export default {
  layout: Layout,
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    sections: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      videoDialog: false,
      videoLoading: false,
      currentVideo: null,
      activeFilter: null,
    };
  },
  computed: {
    filteredSections() {
      if (this.activeFilter === null) {
        return this.sections;
      }
      return [this.sections[this.activeFilter]];
    },
  },
  methods: {
    openVideo(tutorial) {
      this.currentVideo = tutorial;
      this.videoDialog = true;
      this.videoLoading = true;
    },
    currentVideoOnLoad() {
      this.videoLoading = false;
    },
  },
};
</script>

<style scoped>
.filter-chip {
  background: white !important;
  color: #333 !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: none !important;
}
.filter-chip-active {
  background: #1a1a1a !important;
  color: white !important;
  border: 1px solid #1a1a1a !important;
  box-shadow: none !important;
}
.tutorial-card {
  background: #f5f5f5;
  border-radius: 12px;
  transition: background 0.2s;
}
.tutorial-card:hover {
  background: #ececec;
}
.video-dialog-card {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(6px);
}
.video-container {
  width: 80vw;
  max-width: 1200px;
  aspect-ratio: 16 / 9;
}
.video-container iframe {
  width: 100%;
  height: 100%;
}
.loader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
</style>
